import {OrderEditForm} from "../pages/order-view/model/OrderEditForm";
import {DailyTourPlanning} from "./Order";

export class OrderRequest {

  public store: number;
  public operation: number;
  public profil: number;
  public kit: number;

  public reco: string;

  public csPresence: boolean;
  public appointment: string;
  public sharingCustomerSectorContactDetailsToWorker: boolean;
  public appointmentHour: string;
  public appointmentMin: string;

  public storeContact: string;
  public mobileStoreContact: string;
  public storeAccess: string;
  public customerSector: number;
  public missionOrderSource: string;

  public planning: ActivityOrder[] = new Array();
  public planningPurpose: number;
  public plannedPurposes: PlanningMissionPurpose[];

  public dailyTourPlanning: number;

  constructor() {
    this.planning = [];
  }

  setup(orderForm: OrderEditForm) {

    if (orderForm) {

      this.store = orderForm.store.id;
      this.operation = orderForm.operation.id;
      this.missionOrderSource = 'LOCUPA';
      this.customerSector = orderForm.customerSectorId;
      this.profil = orderForm.profil;
      this.kit = orderForm.kit;
      this.planningPurpose = orderForm.planningPurpose;

      this.csPresence = orderForm.csPresence;
      this.appointment = orderForm.appointment;
      this.sharingCustomerSectorContactDetailsToWorker = orderForm.sharingCustomerSectorContactDetailsToWorker;

      if (orderForm.appointmentTime) {
        this.csPresence = true;
        this.appointmentHour = orderForm.appointmentTime.split(":")[0];
        this.appointmentMin = orderForm.appointmentTime.split(":")[1];
      }

      this.dailyTourPlanning = orderForm.dailyTourPlanning;

      this.storeContact = orderForm.storeContact;
      this.mobileStoreContact = orderForm.storeContactMobile;
      this.storeAccess = orderForm.storeContactInfoAccess;

      if (orderForm.uiMissionPlanningDetails != null && orderForm.uiMissionPlanningDetails.length > 0) {
        let plannedP: PlanningMissionPurpose[] = [];
        for (let uiPp of orderForm.uiMissionPlanningDetails) {
          if (uiPp.selected) {
            let newPP = new PlanningMissionPurpose();
            newPP.instructions = uiPp.details;
            newPP.purposeId = uiPp.purposeId;
            plannedP.push(newPP);
          }
        }
        this.plannedPurposes = plannedP;
      }

      for (let p of orderForm.interventions) {

        if (p.logaDate) {

          let activityOrder: ActivityOrder = new ActivityOrder();

          activityOrder.day = p.logaDate;
          this.reco = orderForm.comment;

          // ici startTime est bien une heure HH:MM:SS
          if (p.amStartTime) {
            activityOrder.amStartHour = p.amStartTime.split(':')[0]
            activityOrder.amStartMin = p.amStartTime.split(':')[1]
            activityOrder.amDurationMin = p.amDuration;
          }

          // pour les animations
          if (p.pmStartTime) {
            activityOrder.pmStartHour = p.pmStartTime.split(':')[0]
            activityOrder.pmStartMin = p.pmStartTime.split(':')[1]
            activityOrder.pmDurationMin = p.pmDuration;
          }

          activityOrder.dailyWorkerScheduleTemplateSlotId = p.dailyWorkerScheduleTemplateSlotId;
          activityOrder.planningSlotId = p.planningSlotId;

          this.planning.push(activityOrder);

        }

      }

    }
  }
}

export class ActivityOrder {

  public day: number;
  public amStartHour: string;
  public amStartMin: string;
  public amDurationMin: number;

  public pmStartHour: string;
  public pmStartMin: string;
  public pmDurationMin: number;


  public dailyWorkerScheduleTemplateSlotId: number;
  public planningSlotId: number;

}

/**
 * Callback when a mission has been created
 */
export class MissionOrderCreateStatus {
  missionOrder: number;
  missions: number[];
  currentQuota: number;
  quota: number;
  quotaExceed: boolean;
  complianceInfringements: string[];
  quotaExcededDetails: string;
}

/**
 * Class to sublut a new Mission Cancellation
 */
export class SubmitMissionCustomerCancellation {
  comments: string;
}


export class TourPlanningDuplicateResponse {
  public dailyTourPlanning: DailyTourPlanning;
  public createStatuses: MissionOrderCreateStatus[] = [];
}

export class PlanningMissionPurpose {
  purposeId: number;
  instructions: string;
  id: number;
  purposeName: string;
}



// WEBPACK FOOTER //
// ./src/model/OrderRequest.ts